import { Satellite } from "@mui/icons-material";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showMandate: false,
  disabledUpdateButton: false,
  filterData: {
    applicationValue: "",
    branchValue: "",
    applicationTouch: false,
    branchTouch: false,
    bankAccountNum: "",
    bankAccountNumTouch: false,
  },
  editLock: {
    editLockFlag: "",
    branch: "",
    applicationNumber: "",
  },
  mandateDialogFlag: {
    editLockStatus: "",
  },
  initialLoadData: {
    nachSponserBank: "",
    nachAmount: "",
    frequency: "",
    debitType: "",
    fbd: "",
    mandateStartDate: "",
    mandateValidity: "",
  },
  finalData: {
    nachSponserBank: "",
    nachAmount: "",
    frequency: "",
    debitType: "",
    fbd: "",
    mandateStartDate: "",
    mandateValidity: "",
  },
  data: {
    editLock: "",
    applicationNum: "",
    customerId: "",
    customerName: "",
    repayApplication: "",
    repay: "",
    emiAmt: "0",
    status: "",
    loanAmount: "0",
    disbursementAmount: "0",
    sancationDate: null,
    sponserBankArray: [],
    sponsorBank: "",
    ifscCode: "",
    micr: "",
    bankName: "",
    applicationBranch: "",
    applicationBranchCode: "",
    mandateBranch: "",
    // draweePlace: "",
    bankAccountNum: "",
    bankAccHolderName: "",
    accountType: "",
    mandateNum: "",
    nachAmt: "0",
    mandateAmt: "0",
    frequency: "",
    debitType: "",
    fbd: "",
    mandateStartDate: null,
    firstNachBillingDate: null,
    maximumAmt: "0",
    mandateValidity: "",
    mandateEndDate: "",
    customerMobileNum: "",
    customerEmailId: "",
    frequencyTypeArray: [],
    debitTypeArray: [],
    mandateValidityArray: [],
  },
};
const NachFilterReducer = createSlice({
  name: "Nach",
  initialState: initialState,
  reducers: {
    updateEditLockStatus(state, action) {
      state.mandateDialogFlag.editLockStatus = action.payload;
    },
    updateShowMandate(state, action) {
      state.showMandate = action.payload;
    },
    updateSponserBankArray(state, action) {
      state.data.sponserBankArray = action.payload;
    },
    updateSponserBank(state, action) {
      state.data.sponsorBank = action.payload;
      state.finalData.nachSponserBank = action.payload;
    },
    updateApplicationTouchHandler(state, action) {
      state.filterData.applicationTouch = action.payload;
    },
    updateBankAccountNumTouchHandler(state, action) {
      state.filterData.bankAccountNumTouch = action.payload;
    },
    updateBranchTouchHandler(state, action) {
      state.filterData.branchTouch = action.payload;
    },
    updateFrequencyTypeArray(state, action) {
      state.data.frequencyTypeArray = action.payload;
    },
    updateDebitTypeArray(state, action) {
      state.data.debitTypeArray = action.payload;
    },
    updateMandateValidityArray(state, action) {
      state.data.mandateValidityArray = action.payload;
    },
    updateInitialLoad(state, action) {
      state.initialLoadData.nachSponserBank = action.payload.sponsorBank;
      state.initialLoadData.nachAmount = action.payload.nachAmt;
      state.initialLoadData.frequency = action.payload.frequency;
      state.initialLoadData.debitType = action.payload.debitType;
      state.initialLoadData.fbd = action.payload.fbd;
      state.initialLoadData.mandateStartDate = action.payload.mandateStartDate;
      state.initialLoadData.mandateValidity = action.payload.mandateValidity;

      state.finalData.nachSponserBank = action.payload.sponsorBank;
      state.finalData.nachAmount = action.payload.nachAmt;
      state.finalData.frequency = action.payload.frequency;
      state.finalData.debitType = action.payload.debitType;
      state.finalData.fbd = action.payload.fbd;
      state.finalData.mandateStartDate = action.payload.mandateStartDate;
      state.finalData.mandateValidity = action.payload.mandateValidity;
    },
    updateValues(state, action) {
      state.data.editLock = action.payload.editLock;
      state.data.applicationNum = action.payload.applicationNum;
      state.data.customerId = String(action.payload.customerId);
      state.data.customerName = action.payload.bankAccHolderName;
      state.data.repayApplication = action.payload.repayApplication;
      state.data.repay = action.payload.repay;
      state.data.emiAmt = action.payload.emiAmt;
      state.data.status = action.payload.status;
      state.data.loanAmount = action.payload.loanAmount;
      state.data.disbursementAmount = action.payload.disbursementAmount;
      state.data.sancationDate = action.payload.sanctionDate;
      state.data.sponsorBank = action.payload.sponsorBank;
      state.data.ifscCode = action.payload.ifscCode;
      state.data.micr = action.payload.micr;
      state.data.bankName = action.payload.bankName;
      state.data.applicationBranch = action.payload.applicationBranch;
      state.data.applicationBranchCode = action.payload.applicationBranchCode;
      state.data.mandateBranch = action.payload.branchName;
      // state.data.draweePlace = action.payload.draweePlace;
      state.data.bankAccountNum = action.payload.bankAccountNum;
      state.data.bankAccHolderName = action.payload.bankAccHolderName;
      state.data.accountType = action.payload.accountType;
      state.data.nachAmt = action.payload.nachAmt;
      state.data.mandateAmt = action.payload.mandateAmt;
      state.data.frequency = action.payload.frequency;
      state.data.debitType = action.payload.debitType;
      state.data.fbd = action.payload.fbd;
      state.data.mandateStartDate = action.payload.mandateStartDate;
      state.data.firstNachBillingDate = action.payload.firstNachBillingDate;
      state.data.maximumAmt = action.payload.maximumAmt;
      state.data.mandateValidity = action.payload.mandateValidity;
      state.data.mandateEndDate = action.payload.mandateEndDate;
      state.data.customerMobileNum = action.payload.customerMobileNum;
      state.data.customerEmailId = action.payload.customerEmailId;
      state.data.frequencyTypeArray = action.payload.frequencyTypeArray;
      state.data.debitTypeArray = action.payload.debitTypeArray;
      state.data.mandateValidityArray = action.payload.mandateValidityArray;
    },

    resetValues(state, action) {
      state.data.applicationNum = "";
      state.data.customerId = "";
      state.data.customerName = "";
      state.data.repayApplication = "";
      state.data.repay = "";
      state.data.emiAmt = "0";
      state.data.status = "";
      state.data.loanAmount = "0";
      state.data.disbursementAmount = "0";
      state.data.sancationDate = null;
      state.data.sponsorBank = "";
      state.data.ifscCode = "";
      state.data.micr = "";
      state.data.bankName = "";
      state.data.applicationBranch = "";
      state.data.applicationBranchCode = "";
      state.data.mandateBranch = "";
      // state.data.draweePlace = "";
      state.data.bankAccountNum = "";
      state.data.bankAccHolderName = "";
      state.data.accountType = "";
      state.data.mandateNum = "";
      state.data.nachAmt = "0";
      state.data.mandateAmt = "0";
      state.data.frequency = "";
      state.data.debitType = "";
      state.data.fbd = "";
      state.data.mandateStartDate = "";
      state.data.firstNachBillingDate = "";
      state.data.maximumAmt = "0";
      state.data.mandateValidity = "";
      state.data.mandateEndDate = "";
      state.data.customerMobileNum = "";
      state.data.customerEmailId = "";
      state.data.frequencyTypeArray = [];
      state.data.debitTypeArray = [];
      state.data.mandateValidityArray = [];
    },
    resetFilterValues(state, action) {
      state.filterData.applicationValue = "";
      state.filterData.branchValue = "";
      state.filterData.bankAccountNum = "";
    },
    updateApplicationValue(state, action) {
      state.filterData.applicationValue = action.payload;
    },
    updateBankAccountNumValue(state, action) {
      state.filterData.bankAccountNum = action.payload;
    },
    updateBranchValue(state, action) {
      state.filterData.branchValue = action.payload;
    },
    updateFrequency(state, action) {
      state.data.frequency = action.payload;
      state.finalData.frequency = action.payload;
    },
    updateDebitType(state, action) {
      state.data.debitType = action.payload;
      state.finalData.debitType = action.payload;
    },
    updateMandateValidity(state, action) {
      state.data.mandateValidity = action.payload;
      state.finalData.mandateValidity = action.payload;
    },
    updateFBD(state, action) {
      state.data.fbd = action.payload;
      state.finalData.fbd = action.payload;
    },
    updateMandateStartDate(state, action) {
      state.data.mandateStartDate = action.payload;
      state.finalData.mandateStartDate = action.payload;
    },
    updateFirstNachBillingDate(state, action) {
      state.data.firstNachBillingDate = action.payload;
    },
    updateMandateNum(state, action) {
      state.data.mandateNum = action.payload;
    },
    updateNachAmt(state, action) {
      state.data.nachAmt = action.payload;
      state.finalData.nachAmount = action.payload;
    },
    updateMandateAmt(state, action) {
      state.data.mandateAmt = action.payload;
      // uodate max amount also.
      state.data.maximumAmt = action.payload;
    },
    updateDisablesState(state, action) {
      state.disabledUpdateButton = action.payload;
    },
    updateEditLockFlag(state, action) {
      state.editLock.editLockFlag = action.payload;
    },
    updateEditLockBranch(state, action) {
      state.editLock.branch = action.payload;
    },
    updateEditLockApplicationNumber(state, action) {
      state.editLock.applicationNumber = action.payload;
    },
    //Reducer used to maintain comparision Objects
  },
});
export const NachFilterReducerAction = NachFilterReducer.actions;
export default NachFilterReducer.reducer;
